import { render } from "./componentPopup.vue?vue&type=template&id=5267e7d9&scoped=true&lang=pug"
import script from "./componentPopup.vue?vue&type=script&lang=js"
export * from "./componentPopup.vue?vue&type=script&lang=js"

import "./componentPopup.vue?vue&type=style&index=0&id=5267e7d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5267e7d9"]])

export default __exports__